import React from 'react';
import { Button, Icon, Tooltip } from 'components';
import { AuthContext } from 'contexts';
import styled from 'styled-components';
import MyBrokerageContext from './MyBrokerageContext';

const PRINT_LIMIT = 300;

const PrintButton: React.FC = () => {
  const { auth } = React.useContext(AuthContext);
  const {
    results: { count },
    queryData,
    getFormattedSortData,
  } = React.useContext(MyBrokerageContext);

  const print = () => {
    const params = {
      ...queryData.searchOptions,
      ...getFormattedSortData(),
      address: queryData.searchTerm,
      searchType: 'brokerage',
      type: 'brokerage',
      onboardingPortalId: auth?.org.onboardingPortalId,
    };

    const strParams = Object.keys(params)
      .filter((key: keyof typeof params) => params[key] || params[key] === 0)
      .map((key: keyof typeof params) => `${key}=${params[key]}`)
      .join('&');

    return window.open(`/my_brokerage_tab_pdf?${strParams}`, '_blank');
  };

  const canPrint = count <= PRINT_LIMIT;

  if (!auth?.isAdmin) return <div />;

  return (
    <Tooltip
      title={
        <StyledTooltipContent>
          {canPrint
            ? 'Print PDF'
            : `Cannot Print More Than ${PRINT_LIMIT} Listings`}
        </StyledTooltipContent>
      }
    >
      <Button
        data-cy="print-button"
        icon={<Icon type="download" width={12} />}
        onClick={canPrint ? print : undefined}
      />
    </Tooltip>
  );
};

const StyledTooltipContent = styled.div`
  text-align: center;
`;

export default PrintButton;
